import React from 'react';
import Subheader from 'material-ui/Subheader';
import OrderTag from './OrderTag';

export default class OrderTagGroup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            freeTagName: '',
            freeTagPrice: ''
        };
    }

    isFreeTagGroup = () => {
        return this.props.name === 'Ekstra Seçenekler';
    }

    onFreeTagAdd = () => {
        const tagName = (this.state.freeTagName || '').trim();
        const tagPrice = parseFloat(this.state.freeTagPrice || '0');

        if (!tagName) return;

        const tag = {
            name: tagName,
            quantity: 1,
            price: isNaN(tagPrice) ? 0 : tagPrice
        };

        this.props.onClick(this.props.name, tag);

        this.setState({
            freeTagName: '',
            freeTagPrice: ''
        });
    }

    renderFreeTagArea = () => {
        return (
            <div className="freeTagBox">
                <div className="freeTagInputs">
                    <input
                        type="text"
                        placeholder="Ekstra seçenek adı"
                        value={this.state.freeTagName}
                        onChange={(e) => this.setState({ freeTagName: e.target.value })}
                        className="freeTagInput"
                    />

                    <input
                        type="number"
                        placeholder="Fiyat"
                        value={this.state.freeTagPrice}
                        onChange={(e) => this.setState({ freeTagPrice: e.target.value })}
                        className="freeTagPriceInput"
                    />

                    <button
                        type="button"
                        onClick={this.onFreeTagAdd}
                        className="freeTagAddButton"
                    >
                        Ekle
                    </button>
                </div>
            </div>
        );
    }

    render() {
        const { name, tags = [], onClick = () => { } } = this.props;

        const items = tags.map(({ name, color, labelColor, caption, price }) => {
            const safePrice = Number(price) || 0;
            const displayCaption = safePrice > 0
                ? (caption || name) + ' +' + safePrice.toFixed(2)
                : (caption || name);

            return (
                <OrderTag
                    key={name + this.props.name}
                    name={name}
                    groupName={this.props.name}
                    caption={displayCaption}
                    color={color}
                    labelColor={labelColor}
                    price={safePrice}
                    onClick={onClick}
                />
            );
        });

        return (
            <div className='orderTagGroupSection'>
                <Subheader>{name}</Subheader>

                {this.isFreeTagGroup() && this.renderFreeTagArea()}

                <div className='orderTagGroup'>
                    {items}
                </div>
            </div>
        );
    }
}

/*
export default class OrderTagGroup extends React.Component {
    render() {
        const {name, tags = [], onClick = () => { } } = this.props;
        const style = {
            'display': 'flex',
            'flexWrap': 'wrap'
        };
        const style2 = {
            'height': 'auto'
        };

        var items = tags.map(({name, color, labelColor, caption}) =>
            <OrderTag key={name + this.props.name}
                name={name}
                groupName={this.props.name}
                caption={caption}
                color={color}
                labelColor={labelColor}
                onClick={onClick}/>);

        return (
            <div className='orderTagGroupSection'>
                <Subheader>{name}</Subheader>
                <div className='orderTagGroup'>
                    {items}
                </div>
            </div>);
    }
}
    */


// WEBPACK FOOTER //
// ./app/components/OrderTagGroup.jsx